import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import EmailVerificationPageUI from './EmailVerificationPageUI.js'

class EmailVerificationPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null
    }
  }

  render() {
    return (
      <EmailVerificationPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
      />
    )
  }

  // https://teambrew.com/pub/email-verification?email=dev-21@moebli.com&code=92qEp8OnH7jsdYk8lJtw
  componentDidMount() {
    let context = this.props.context
    this.verifyEmail(context)
    this.getMessages(context)
  }

  verifyEmail(context) {
    let params = new URLSearchParams(window.location.search)
    let email = params.has('email') ? params.get('email') : ''
    let code = params.has('code') ? params.get('code') : ''
    console.log(email, code);
    RestApiUtils.post(this.props.context,
      `/api/pub/email-verification`,
      this.verifyEmailCallback, {
        email: email,
        code: code
      }
    )
  }

  verifyEmailCallback = (response) => {
    this.setState({
      errorList: response.errorList
    })
  }

  getMessages(context) {
    let arr = [
      'c_continue',
      'c_email_verified',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_email_verif', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(EmailVerificationPageSF)
